export default __webpack_public_path__ + "static/media/graphics_banner_3_drone.b130f6f9.png";